import { Routes } from '@angular/router';
import { permissionGuard } from './core/entitlements/permission.guard';
import { PERMISSIONS } from './core/auth/permissions.const';
import { BeneficiaryRegistryRepository } from './features/beneficiaries/services/beneficiary-registry.repository';
import { BeneficiaryRegistryHttpRepository } from './features/beneficiaries/services/beneficiary-registry.http';
import { BeneficiaryRegistryDownloadStore } from './features/beneficiaries/state/beneficiary-registry-download.store';
import { BeneficiaryRegistryStore } from './features/beneficiaries/state/beneficiary-registry.store';
import { AggregatedReportingRepository } from './features/beneficiaries/services/aggregated-reporting.repository';
import { AggregatedReportingHttpRepository } from './features/beneficiaries/services/aggregated-reporting.http';
import { AggregatedReportingStore } from './features/beneficiaries/state/aggregated-reporting.store';
import { InteractionLogRepository } from './features/beneficiaries/services/interaction-log/interaction-log.repository';
import { InteractionLogHttpRepository } from './features/beneficiaries/services/interaction-log/interaction-log.http';
import { InteractionLogStore } from './features/beneficiaries/state/interaction-log.store';
import { StaffVigenteRepository } from './features/staff-convenio/services/staff-vigente.repository';
import { StaffVigenteHttpRepository } from './features/staff-convenio/services/staff-vigente.http';
import { StaffVigenteDownloadRepository } from './features/staff-convenio/services/staff-vigente-download.repository';
import { StaffVigenteDownloadHttpRepository } from './features/staff-convenio/services/staff-vigente-download.http';
import { StaffCatalogRepository } from './features/staff-convenio/services/staff-catalog.repository';
import { StaffCatalogHttpRepository } from './features/staff-convenio/services/staff-catalog.http';
import { StaffBajaStore } from './features/staff-convenio/state/staff-baja.store';
import { StaffPlantillaRepository } from './features/staff-convenio/services/staff-plantilla.repository';
import { StaffPlantillaHttpRepository } from './features/staff-convenio/services/staff-plantilla.http';
import { StaffPlantillaService } from './features/staff-convenio/services/staff-plantilla.service';
import { StaffAltaValidationRepository } from './features/staff-convenio/services/staff-alta-validation.repository';
import { StaffAltaProcessHttpRepository } from './features/staff-convenio/services/staff-alta-process.http';
import { StaffAltaProcessRepository } from './features/staff-convenio/services/staff-alta-process.repository';
import { StaffAltaValidationHttpRepository } from './features/staff-convenio/services/staff-alta-validation.http';
import { StaffAltaStore } from './features/staff-convenio/state/staff-alta.store';
import { StaffBajaEliminarRepository } from './features/staff-convenio/services/staff-baja-eliminar.repository';
import { StaffChangeHistoryRepository } from './features/staff-convenio/services/staff-change-history/staff-change-history.repository';
import { StaffChangeHistoryHttpRepository } from './features/staff-convenio/services/staff-change-history/staff-change-history.http';
import { StaffChangeHistoryStore } from './features/staff-convenio/state/staff-change-history.store';
import { StaffBajaEliminarHttpRepository } from './features/staff-convenio/services/staff-baja-eliminar.http';
import { StaffBajaValidationRepository } from './features/staff-convenio/services/staff-baja-validation.repository';
import { StaffBajaValidationHttpRepository } from './features/staff-convenio/services/staff-baja-validation.http';
import { HospitalAccountRepository } from './features/gestion-prestador/services/hospital-account.repository';
import { HospitalAccountHttpRepository } from './features/gestion-prestador/services/hospital-account.http';
import { HospitalAccountsStore } from './features/gestion-prestador/state/hospital-accounts.store';
import { HospitalAccountExportStore } from './features/gestion-prestador/state/hospital-account-export.store';
import { HospitalAccountDownloadRepository } from './features/gestion-prestador/services/hospital-account-download.repository';
import { HospitalAccountDownloadHttpRepository } from './features/gestion-prestador/services/hospital-account-download.http';
import { PaymentOrderRepository } from './features/gestion-prestador/services/payment-order.repository';
import { PaymentOrderHttpRepository } from './features/gestion-prestador/services/payment-order.http';
import { SettlementRepository } from './features/gestion-prestador/cobros-bonos/services/settlement.repository';
import { SettlementQueryRepository } from './features/gestion-prestador/cobros-bonos/services/settlement-query.repository';
import { SettlementQueryMockRepository } from './features/gestion-prestador/cobros-bonos/services/settlement-query.mock';
import { SettlementDetailStore } from './features/gestion-prestador/cobros-bonos/state/settlement-detail.store';
import { SettlementActionRepository } from './features/gestion-prestador/cobros-bonos/services/settlement-action.repository';
import { SettlementActionMockRepository } from './features/gestion-prestador/cobros-bonos/services/settlement-action.mock';
import { SettlementActionStore } from './features/gestion-prestador/cobros-bonos/state/settlement-action.store';
import { SettlementLinkStore } from './features/gestion-prestador/cobros-bonos/state/settlement-link.store';
import { SettlementStatusOptionsStore } from './features/gestion-prestador/cobros-bonos/state/settlement-status-options.store';
import { SettlementsStore } from './features/gestion-prestador/cobros-bonos/state/settlements.store';
import { SettlementMockRepository } from './features/gestion-prestador/cobros-bonos/services/settlement.mock';
import { SettlementCreateStore } from './features/gestion-prestador/cobros-bonos/state/settlement-create.store';
import { SettlementLoadFormStore } from './features/gestion-prestador/cobros-bonos/state/settlement-load-form.store';
import { PaymentOrdersStore } from './features/gestion-prestador/state/payment-orders.store';
import { ProviderProfileRepository } from './features/gestion-prestador/services/provider-profile.repository';
import { ProviderProfileHttpRepository } from './features/gestion-prestador/services/provider-profile.http';
import { ProviderProfileStore } from './features/gestion-prestador/state/provider-profile.store';
import { PendingBonusRepository } from './features/gestion-prestador/emision-bonos/services/pending-bonus.repository';
import { PendingBonusHttpRepository } from './features/gestion-prestador/emision-bonos/services/pending-bonus.http';
import { PayrollRepository } from './features/gestion-prestador/emision-bonos/services/payroll.repository';
import { PayrollHttpRepository } from './features/gestion-prestador/emision-bonos/services/payroll.http';
import { PayrollPdfStore } from './features/gestion-prestador/emision-bonos/state/payroll-pdf.store';
import { PayrollsStore } from './features/gestion-prestador/emision-bonos/state/payrolls.store';
import { BonusIssueStore } from './features/gestion-prestador/emision-bonos/state/bonus-issue.store';
import { PendingBonusDetailStore } from './features/gestion-prestador/emision-bonos/state/pending-bonus-detail.store';
import { PendingBonusesStore } from './features/gestion-prestador/emision-bonos/state/pending-bonuses.store';
import { ReportLinkDownloadHttpRepository } from './features/home/services/report-link-download.http';
import { ReportLinkDownloadRepository } from './features/home/services/report-link-download.repository';
import { ReportLinkDownloadStore } from './features/home/state/report-link-download.store';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    providers: [
      ReportLinkDownloadStore,
      { provide: ReportLinkDownloadRepository, useClass: ReportLinkDownloadHttpRepository },
    ],
    loadComponent: () => import('./features/home/pages/home.page').then((m) => m.HomePageComponent),
  },
  {
    path: 'beneficiarios/padron-beneficiarios',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.BENEFICIARIOS_PADRON_READ },
    providers: [
      BeneficiaryRegistryStore,
      BeneficiaryRegistryDownloadStore,
      { provide: BeneficiaryRegistryRepository, useClass: BeneficiaryRegistryHttpRepository },
    ],
    loadComponent: () =>
      import('./features/beneficiaries/pages/beneficiary-registry.page').then(
        (m) => m.BeneficiaryRegistryPageComponent,
      ),
  },
  {
    path: 'beneficiarios/consulta-unitaria',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.BENEFICIARIOS_CONSULTA_READ },
    loadComponent: () =>
      import('./features/beneficiaries/pages/single-query/single-query.page').then(
        (m) => m.SingleQueryPageComponent,
      ),
  },
  {
    path: 'beneficiarios/consulta-rut-titular',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.BENEFICIARIOS_TITULAR_READ },
    loadComponent: () =>
      import('./features/beneficiaries/pages/rut-titular-query/rut-titular-query.page').then(
        (m) => m.RutTitularQueryPageComponent,
      ),
  },
  {
    path: 'beneficiarios/reporteria-agregada',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.BENEFICIARIOS_REPORTERIA_READ },
    providers: [
      AggregatedReportingStore,
      { provide: AggregatedReportingRepository, useClass: AggregatedReportingHttpRepository },
    ],
    loadComponent: () =>
      import('./features/beneficiaries/pages/reporteria-agregada/reporteria-agregada.page').then(
        (m) => m.AggregatedReportingPageComponent,
      ),
  },
  {
    path: 'beneficiarios/historial-interaccion',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.BENEFICIARIOS_HISTORIAL_READ },
    providers: [
      InteractionLogStore,
      { provide: InteractionLogRepository, useClass: InteractionLogHttpRepository },
    ],
    loadComponent: () =>
      import('./features/beneficiaries/pages/historial-interaccion/historial-interaccion.page').then(
        (m) => m.HistorialInteraccionPageComponent,
      ),
  },
  {
    path: 'staff-convenio/listado-staff',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.STAFF_VIGENTE_READ },
    providers: [
      { provide: StaffVigenteRepository, useClass: StaffVigenteHttpRepository },
      { provide: StaffVigenteDownloadRepository, useClass: StaffVigenteDownloadHttpRepository },
      { provide: StaffCatalogRepository, useClass: StaffCatalogHttpRepository },
    ],
    loadComponent: () =>
      import('./features/staff-convenio/pages/staff-vigente.page').then(
        (m) => m.StaffVigentePageComponent,
      ),
  },
  {
    path: 'staff-convenio/alta-staff',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.STAFF_ALTA_CREATE },
    providers: [
      StaffAltaStore,
      StaffPlantillaService,
      { provide: StaffPlantillaRepository, useClass: StaffPlantillaHttpRepository },
      { provide: StaffAltaValidationRepository, useClass: StaffAltaValidationHttpRepository },
      { provide: StaffAltaProcessRepository, useClass: StaffAltaProcessHttpRepository },
    ],
    loadComponent: () =>
      import('./features/staff-convenio/pages/staff-alta.page').then(
        (m) => m.StaffAltaPageComponent,
      ),
  },
  {
    path: 'staff-convenio/baja-staff',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.STAFF_BAJA_DELETE },
    providers: [
      StaffBajaStore,
      StaffPlantillaService,
      { provide: StaffPlantillaRepository, useClass: StaffPlantillaHttpRepository },
      { provide: StaffBajaValidationRepository, useClass: StaffBajaValidationHttpRepository },
      { provide: StaffBajaEliminarRepository, useClass: StaffBajaEliminarHttpRepository },
    ],
    loadComponent: () =>
      import('./features/staff-convenio/pages/staff-baja.page').then(
        (m) => m.StaffBajaPageComponent,
      ),
  },
  {
    path: 'staff-convenio/historial-cambios',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.STAFF_HISTORIAL_READ },
    providers: [
      StaffChangeHistoryStore,
      { provide: StaffChangeHistoryRepository, useClass: StaffChangeHistoryHttpRepository },
    ],
    loadComponent: () =>
      import('./features/staff-convenio/pages/historial-cambios/historial-cambios.page').then(
        (m) => m.ChangeHistoryComponent,
      ),
  },
  {
    path: 'gestion-prestador/antecedentes-prestador',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.PRESTADOR_ANTECEDENTES_READ },
    providers: [
      ProviderProfileStore,
      { provide: ProviderProfileRepository, useClass: ProviderProfileHttpRepository },
    ],
    loadComponent: () =>
      import('./features/gestion-prestador/pages/antecedentes-prestador.page').then(
        (m) => m.AntecedentesPrestadorPageComponent,
      ),
  },
  {
    path: 'gestion-prestador/fechas-pago',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.PRESTADOR_PAGOS_READ },
    providers: [
      PaymentOrdersStore,
      { provide: PaymentOrderRepository, useClass: PaymentOrderHttpRepository },
    ],
    loadComponent: () =>
      import('./features/gestion-prestador/pages/fechas-pago.page').then(
        (m) => m.FechasPagoPageComponent,
      ),
  },
  {
    path: 'gestion-prestador/cuentas-hospitalarias',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.PRESTADOR_CUENTAS_READ },
    providers: [
      HospitalAccountsStore,
      HospitalAccountExportStore,
      { provide: HospitalAccountRepository, useClass: HospitalAccountHttpRepository },
      {
        provide: HospitalAccountDownloadRepository,
        useClass: HospitalAccountDownloadHttpRepository,
      },
    ],
    loadComponent: () =>
      import('./features/gestion-prestador/pages/cuentas-hospitalarias.page').then(
        (m) => m.CuentasHospitalariasPageComponent,
      ),
  },
  {
    path: 'gestion-prestador/emision-bonos/emitir-bono',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.PRESTADOR_BONOS_CREATE },
    providers: [
      PendingBonusesStore,
      PendingBonusDetailStore,
      BonusIssueStore,
      { provide: PendingBonusRepository, useClass: PendingBonusHttpRepository },
    ],
    loadComponent: () =>
      import('./features/gestion-prestador/emision-bonos/pages/emitir-bonos.page').then(
        (m) => m.EmitirBonosPageComponent,
      ),
  },
  {
    path: 'gestion-prestador/emision-bonos/nomina',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.PRESTADOR_NOMINAS_READ },
    providers: [
      PayrollsStore,
      PayrollPdfStore,
      { provide: PayrollRepository, useClass: PayrollHttpRepository },
    ],
    loadComponent: () =>
      import('./features/gestion-prestador/emision-bonos/pages/nomina.page').then(
        (m) => m.NominaPageComponent,
      ),
  },
  {
    path: 'gestion-prestador/cobros-bonos/cargar-bonos',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.PRESTADOR_CARGAS_CREATE },
    providers: [
      SettlementLoadFormStore,
      SettlementCreateStore,
      // TODO: cambiar a SettlementHttpRepository cuando el BFF exponga los endpoints de CA-800.
      { provide: SettlementRepository, useClass: SettlementMockRepository },
    ],
    loadComponent: () =>
      import('./features/gestion-prestador/cobros-bonos/pages/cargar-bonos.page').then(
        (m) => m.CargarBonosPageComponent,
      ),
  },
  {
    path: 'gestion-prestador/cobros-bonos/liquidaciones',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.PRESTADOR_LIQUIDACIONES_READ },
    providers: [
      SettlementsStore,
      SettlementStatusOptionsStore,
      SettlementActionStore,
      SettlementLinkStore,
      // TODO: cambiar a los repositorios HTTP cuando el BFF exponga detalle, bonos y acciones (CA-787).
      { provide: SettlementQueryRepository, useClass: SettlementQueryMockRepository },
      { provide: SettlementActionRepository, useClass: SettlementActionMockRepository },
    ],
    loadComponent: () =>
      import('./features/gestion-prestador/cobros-bonos/pages/liquidaciones.page').then(
        (m) => m.LiquidacionesPageComponent,
      ),
  },
  {
    path: 'gestion-prestador/cobros-bonos/liquidaciones/:settlementId',
    canActivate: [permissionGuard],
    data: { permission: PERMISSIONS.PRESTADOR_LIQUIDACIONES_READ },
    providers: [
      SettlementDetailStore,
      SettlementActionStore,
      SettlementLinkStore,
      // TODO: cambiar a los repositorios HTTP cuando el BFF exponga cabecera, bonos y acciones (CA-800, CA-787).
      { provide: SettlementQueryRepository, useClass: SettlementQueryMockRepository },
      { provide: SettlementActionRepository, useClass: SettlementActionMockRepository },
    ],
    loadComponent: () =>
      import('./features/gestion-prestador/cobros-bonos/pages/liquidacion-detalle.page').then(
        (m) => m.LiquidacionDetallePageComponent,
      ),
  },
  {
    path: 'guia-mensajes',
    loadComponent: () =>
      import('./features/styleguide/pages/styleguide.page').then((m) => m.StyleguidePageComponent),
  },

  { path: '**', redirectTo: '' },
];
